import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import { attachReadOnlyInterceptor } from '@/axios/read-only-interceptor'

class Items {
  constructor () {
    const base = axios.create({
      // using base items api
      baseURL: process.env.VUE_APP_ITEMS_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      }
    })
    this.items = attachReadOnlyInterceptor(base)
    this.cancelTokenSource = null
  }

  cancelSearch() {
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel()
      this.cancelTokenSource = null
    }
  }

  async getSourceRelsByPartyId (partyId) {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })

    return this.items({
      url: `/source/relationships/party/${partyId}`,
      method: 'GET'
    })
  }

  async getGroupsByItem (source, item_id, offset = 0, limit = 50) {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })

    return this.items({
      url: `/item-groups`,
      method: 'GET',
      params: { source, item_id, offset, limit }
    })
  }

  async* getGroupItems (groupId, active = true, offset = 0, limit = 200) {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })
    let page = 1
     while (true) {
      offset = (page * limit) - limit
      const res = await this.items({
        url: `/item-group/${groupId}/items`,
        method: 'GET',
        params: { active, offset, limit }
      })
      if (!res.data || res.data.length === 0) {
        break
      }
      yield res.data
      if (res.data.length < limit) break
      page++
    }
  }

  async* searchItems(payload, offset = 0, limit = 300) {
    this.cancelTokenSource = axios.CancelToken.source()
    try {
      await AuthToken.setAuth(this.items, {
        audience: process.env.VUE_APP_ITEM_AUDIENCE
      })
      let page = 1
      while (true) {
        offset = (page * limit) - limit
        const res = await this.items({
          url: `/item_search/`,
          method: 'POST',
          data: payload,
          params: { offset, limit },
          cancelToken: this.cancelTokenSource.token
        })
        if (!res.data || res.data.length === 0) {
          break
        }
        yield res.data
        if (res.data.length < limit) break
        page++
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        throw new Error('Search was cancelled by user')
      }
      throw error
    }
  }
}

export default new Items()